var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgGridAdd = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 9.33335V13.3334M9.33329 11.3334H13.3333M3.99996 6.66669H5.33329C6.06967 6.66669 6.66663 6.06973 6.66663 5.33335V4.00002C6.66663 3.26364 6.06967 2.66669 5.33329 2.66669H3.99996C3.26358 2.66669 2.66663 3.26364 2.66663 4.00002V5.33335C2.66663 6.06973 3.26358 6.66669 3.99996 6.66669ZM10.6666 6.66669H12C12.7363 6.66669 13.3333 6.06973 13.3333 5.33335V4.00002C13.3333 3.26364 12.7363 2.66669 12 2.66669H10.6666C9.93025 2.66669 9.33329 3.26364 9.33329 4.00002V5.33335C9.33329 6.06973 9.93025 6.66669 10.6666 6.66669ZM3.99996 13.3334H5.33329C6.06967 13.3334 6.66663 12.7364 6.66663 12V10.6667C6.66663 9.93031 6.06967 9.33335 5.33329 9.33335H3.99996C3.26358 9.33335 2.66663 9.93031 2.66663 10.6667V12C2.66663 12.7364 3.26358 13.3334 3.99996 13.3334Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGridAdd, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/grid-add.07963c53.svg";
export { ForwardRef as ReactComponent };